/* tslint:disable */
/* eslint-disable */
/**
 * esign
 * eSign template authoring and request management service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const EsignRequestActivityType = {
    RequestCreated: 'request_created',
    TemplateSelected: 'template_selected',
    RequestFinalized: 'request_finalized',
    EmailSent: 'email_sent',
    ReminderSent: 'reminder_sent',
    SignerCompleted: 'signer_completed',
    RequestCompleted: 'request_completed',
    RequestCancelled: 'request_cancelled',
    EhrPushed: 'ehr_pushed',
    CompletedDocumentLinksSent: 'completed_document_links_sent',
    CompletedDocumentLinkRevoked: 'completed_document_link_revoked'
} as const;
export type EsignRequestActivityType = typeof EsignRequestActivityType[keyof typeof EsignRequestActivityType];


export function EsignRequestActivityTypeFromJSON(json: any): EsignRequestActivityType {
    return EsignRequestActivityTypeFromJSONTyped(json, false);
}

export function EsignRequestActivityTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): EsignRequestActivityType {
    return json as EsignRequestActivityType;
}

export function EsignRequestActivityTypeToJSON(value?: EsignRequestActivityType | null): any {
    return value as any;
}

